import React from 'react';

import './styles/preloading.css';
import './scripts/serviceWorker';
import './scripts/updateViewPort';

import useLoadTenantConfigs from './hooks/useLoadTenantConfigs';
import BrowserCompatibility from './components/BrowserCompatibility';
import Preconnect from './components/Preconnect';
import PageTitle from './components/PageTitle';
import BranchIoScript from './components/BranchIoScript';
import GoogleTagManagerScript from './components/GoogleTagManagerScript';
import MetaPixelScript from './components/MetaPixelScript';
import FaviconAndManifest from './components/FaviconAndManifest';
import GlobalCssVariables from './components/GlobalCssVariables';

function BrandingProvider({ appType, children, title = null, isWithBranchIo = false }) {
  const loaded = useLoadTenantConfigs(appType);
  if (!loaded) {
    return null;
  }

  return (
    <>
      <BrowserCompatibility />
      <Preconnect />
      <PageTitle suffix={title} />
      <FaviconAndManifest />
      <GlobalCssVariables />

      <GoogleTagManagerScript appType={appType} />
      <MetaPixelScript appType={appType} />
      {isWithBranchIo && <BranchIoScript />}

      {children}
    </>
  );
}

export default BrandingProvider;
